import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=4e673fdf&scoped=true&"
import script from "./settlementDetails.vue?vue&type=script&lang=js&"
export * from "./settlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=4e673fdf&lang=scss&scoped=true&"
import style1 from "./settlementDetails.vue?vue&type=style&index=1&id=4e673fdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e673fdf",
  null
  
)

export default component.exports